import {Model} from 'backbone';

class TypeSelection extends Model.extend({
  url: '/api/typeselection'
}) {}

export default TypeSelection;
